/*!

=========================================================
* Paper Dashboard PRO React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "views/manager/Login";

/**
 * The login page, and nothing else. This layout is in the main bundle, so it
 * imports the page directly rather than `routes.js`: reading the one `/auth`
 * route out of that list used to pull every dashboard page in behind it.
 */
function Pages() {
  return (
    <div className="min-h-screen">
      <Routes>
        <Route path="/login" element={<Login />} />
      </Routes>
    </div>
  );
}

export default Pages;
